import { render, staticRenderFns } from "./ContentComponent.vue?vue&type=template&id=f6b5b8e0&"
import script from "./ContentComponent.vue?vue&type=script&lang=js&"
export * from "./ContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContentComponent.vue?vue&type=style&index=0&id=f6b5b8e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports